import React,{useState, useEffect, useRef} from 'react';
import Toastify from '../Toastify/index';
import {PostFile} from '../../services/servicesPostFile';
import ImageEditor from '@toast-ui/react-image-editor/';
import 'tui-image-editor/dist/tui-image-editor.css';
import './style.css' ;
import LoadScreenSmall from '../loadScreenSmall/loadScreenSmall';
const myTheme = {
    "downloadButton.backgroundColor": "white",
    "downloadButton.borderColor": "white",
    "downloadButton.color": "black",
    "downloadButton.display": "unset",
};
const textoTraduzido = {
    'DeleteAll': 'Apagar Todos',
    'Load':'Carregar Imagem',
    'Load Mask Image':'Inserir Logo',
    'Crop':'Cortar',
    'Filter':'Filtros',
    'Mask':'Inserir Logo',
    'Rotate':'Girar',
}

export default function EditorImage(props){

    const imageEditor = useRef();
    const [loadSmall, setLoadSmall] = useState(false);

    async function postFile(name,size,type,base64){
       try{
           const objPost = [{name,size,type},base64]
           const arquivo = await PostFile(objPost);
        //    debugger
           return arquivo;
       }catch(error){
            console.log(error);
            Toastify.error('Não foi possivel carregar a imagem');
       }
   }

    function closeEditor(){
        props.close(false)
    }

    function init(){
        let header = document.querySelectorAll('.tui-image-editor-header-logo');
        let headerButton = document.querySelectorAll('.tui-image-editor-header-buttons');
        let downloadButton = document.querySelectorAll('.tui-image-editor-download-btn');
        let applyButtonMask = document.getElementsByClassName('tie-mask-apply tui-image-editor-newline apply');
        let zoomOutButton = document.getElementsByClassName('tie-btn-zoomOut tui-image-editor-item help');
        let zoomInButton = document.getElementsByClassName('tie-btn-zoomIn tui-image-editor-item help');
        let handsHelpButton = document.getElementsByClassName('tie-btn-hand tui-image-editor-item help');
        handsHelpButton[0].setAttribute('style','display:none');
        zoomInButton[0].setAttribute('style','display:none');
        zoomOutButton[0].setAttribute('style','display:none');
        applyButtonMask[0].setAttribute('style','display:none');
        console.log(applyButtonMask);
        downloadButton[0].setAttribute('style','display:none');
        downloadButton[1].setAttribute('style','display:none');
        header[0].setAttribute('style','display:none');
        headerButton[0].setAttribute('style',
            `width: 100%;
            display: flex;
            justify-content: space-around;
            align-items: center;`
        );
        let newButton = document.createElement('button');
        newButton.innerHTML = 'Salvar Alterações';
        newButton.style.color = '#000';
        newButton.style.background = '#fff';
        newButton.onclick = saveImageToDisk;
        newButton.classList.add('tui-image-editor-download-btn');
        headerButton[0].appendChild(newButton);
        let buttonAddTitle = document.createElement('button');
        buttonAddTitle.innerText = 'Inserir título';
        buttonAddTitle.style.color = '#000';
        buttonAddTitle.style.background = '#fff';
        buttonAddTitle.onclick = addTitle;
        headerButton[0].appendChild(buttonAddTitle);
        let newButton2 = document.createElement('button');
        newButton2.style.color = '#000';
        newButton2.style.background = '#fff';
        newButton2.innerHTML = 'Cancelar';
        newButton2.onclick = closeEditor;
        newButton2.classList.add('tui-image-editor-download-btn');
        headerButton[0].appendChild(newButton2);
    }

    useEffect(()=>{
       initialize()
    },[])

    async function initialize(){
        setLoadSmall(true)
        await init();
        await addimageobject();
        setLoadSmall(false);
    }

    const addimageobject = async()=> {
        try{
            // debugger
            const imagem = await imageEditor.current.imageEditorInst.loadImageFromURL(props.image,'teste');
            // console.log(imagem);
        }catch(error){
            console.log('não carregou a imagem')
        }
    }

    const saveImageToDisk = async () => {
        setLoadSmall(true);
        const imageEditorInst = imageEditor.current.imageEditorInst;
        const data = imageEditorInst.toDataURL();
        if (imageEditorInst._graphics.canvasImage) {
            // console.log(data)
            // props.loadScreen(true);
            const timestamp = new Date().getTime();
            const string64 = data.split('base64,');
            const filesize = string64[1].length *(3/4) -1;
            const mimeType = data.split(";")[0].split(':')[1];
            const arquivo = await postFile('imagemEditada'+timestamp+'.jpg',filesize,mimeType,data);
            // debugger
            if(arquivo.resposta){
                props.exibe(oldData=>{
                return  {...oldData,Image1:arquivo.arquivo}
                })
                props.close(false);
                setLoadSmall(false);
                // props.loadScreen(false);
            }else{
                // props.loadScreen(false);
                Toastify.error('Erro ao carregar a imagem');
                setLoadSmall(false);
            }
        //   const extension = data.split(";")[0].split("/")[1];
        //   download(data, `image.${extension}`, mimeType);
        }else{
            Toastify.warning('Insira uma imagem');
            setLoadSmall(false);
        }
      };
    async function addTitle(){
        try {
            const newText = await imageEditor.current.imageEditorInst.addText(props.text,{
                styles:{
                    fill:'#000',
                    fontFamily:'sans-serif',
                    fontSize: 30,
                    textDecoration:'overline',
                    left:0,
                    top:0
                },
                autofocus:false,
                position:{x:10,y:10}
            })
        } catch (error) {
            console.error(error)
        }

    }
    return<> <ImageEditor

        includeUI={{
            locale:textoTraduzido,
            theme: myTheme,
            menu: ['mask','crop','rotate','filter','text'],
            initMenu: 'mask',
            uiSize: {
                width: window.screen.width < 800?'100vw':'1000px',
                height:window.screen.width < 800? '85vh':'700px',
            },
            menuBarPosition: window.screen.width < 800?'bottom':'right',
            loadImage:{
                path:props.image,
                name:'teste'
            }
        }}
        cssMaxHeight={window.screen.width < 800?300:500}
        cssMaxWidth={window.screen.width < 800?300:500}
        selectionStyle={{
        cornerSize: 20,
        rotatingPointOffset: 70,
        }}
        usageStatistics={true}
        ref={imageEditor}
        >

        </ImageEditor>
        {loadSmall ? <LoadScreenSmall open={loadSmall} close={setLoadSmall}  />: ''}
    </>
}
